import MiddlePanel from 'Components/MiddlePanel/MiddlePanel';
import Panel from 'Components/Panel/Panel';
import { useEffect, useState } from 'react';
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import AutomaticallyListedAttributes from 'Components/AutomaticallyListedAttributes/AutomaticallyListedAttributes';
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';
import ApplyAttributes from 'Components/ApplyAttributes/ApplyAttributes';
import Button from 'Components/Button/Button';
import ResetVariables from 'Components/ResetVariables/ResetVariables';
import RemoveIdsNotFound from 'Components/RemoveIdsNotFound/RemoveIdsNotFound';

const HistoryChangePanel = ({
    comboBoxYear,
    itemCostIdSelected,
    onUpdateShowHistoryChangePanel,
    showHistoryChangePanel
}) => {
    const [idItemMonth, setIdItemMonth] = useState(null)
    const [dsItem, setDsItem] = useState(null)
    const [selectedMonth, setSelectedMonth] = useState(null)
    const [budgetLimit, setBudgetLimit] = useState(null)
    const [dtUpdate, setDtUpdate] = useState(null)
    const [username, setUsername] = useState(null)

    const [recordsHistoryChange, setRecordsHistoryChange] = useState(null)
    const [recordsHistoryChangeDetail, setRecordsHistoryChangeDetail] = useState(null)
    const [selectsRecordsHistoryChange, setSelectsRecordsHistoryChange] = useState([])
    const [updating, setUpdating] = useState(false)

    const attributeList = [
        { name: "id", allowsMultipleRecordsSelected: true, value: idItemMonth, setter: setIdItemMonth },
        { name: "dsItem", value: dsItem, setter: setDsItem },
        { name: "selectedMonth", value: selectedMonth, setter: setSelectedMonth },
        { name: "budgetLimit", value: budgetLimit, setter: setBudgetLimit },
        { name: "username", value: username, setter: setUsername },
        { name: "dtUpdate", value: dtUpdate, setter: setDtUpdate }
    ];

    const panelListStyle = {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%'
    };

    useEffect(() => {
        reloadHistoryChangePanel()
    }, []);

    useEffect(() => {
        reloadHistoryChangePanel()
    }, [itemCostIdSelected, showHistoryChangePanel]);

    useEffect(() => {
        if (!updating) {
            reloadHistoryChangePanel()
        }
    }, [updating]);

    function reloadHistoryChangePanel() {
        if (itemCostIdSelected && itemCostIdSelected.length === 1) {
            getHistoryChangeRecordsGrid(itemCostIdSelected[0])
        } else {
            getHistoryChangeRecordsGrid(null)
        }
    }

    async function getHistoryChangeRecordsGrid(itemCostIdSelected) {
        const parameters = {
            selectedYear: comboBoxYear,
            itemCostId: itemCostIdSelected ? itemCostIdSelected : 0
        }
        const historyChangePanelGrid = await ExecuteAxios.api('get', `/item-cost-month/get-item-cost-month-grid/`, { params: parameters });
        setRecordsHistoryChange(historyChangePanelGrid);
        RemoveIdsNotFound.remove(historyChangePanelGrid, setSelectsRecordsHistoryChange, selectsRecordsHistoryChange)
    }

    useEffect(() => {
        if (selectsRecordsHistoryChange.length == 1) {
            getHistoryChangeRecordsDetail(selectsRecordsHistoryChange[0])
        }
    }, [selectsRecordsHistoryChange, updating]);

    async function getHistoryChangeRecordsDetail(idItemHistoryChangeSelected) {
        const parameters = {
            id: idItemHistoryChangeSelected
        }
        const historyChangePanelDetail = await ExecuteAxios.api('get', `/item-cost-month/get-item-cost-month-detail/`, { params: parameters });
        setRecordsHistoryChangeDetail(historyChangePanelDetail);
        if (historyChangePanelDetail) {
            ApplyAttributes.applyAttributes(historyChangePanelDetail, attributeList)
        }
    }

    const getPanelListOrDetail = () => {
        if (!updating) {
            return (
                <PanelListDefault
                    onUpdateIdSelected={setSelectsRecordsHistoryChange}
                    idsSelected={selectsRecordsHistoryChange}
                    data={recordsHistoryChange}
                    attributeList={attributeList}
                />
            )
        } else {
            return (
                <AutomaticallyListedAttributes
                    list={recordsHistoryChangeDetail}
                    attributeList={attributeList}
                />
            )
        }
    }

    const cancelFunction = () => {
        setUpdating(false)
    }

    async function putProductOperation() {
        return await ExecuteAxios.api('put', `/item-cost-month/`, {
            id: idItemMonth,
            budgetLimit: budgetLimit
        });
    }

    const styleHistoryChangeButton = {
        width: '80px',
        float: 'right',
        color: 'red',
        fontWeight: '600',
        textAlign: 'center',
        fontSize: '0.8em',
        cursor: 'pointer',
        height: '30px'
    };

    function closeButton() {
        return (
            <Button
                clickMethod={() => { onUpdateShowHistoryChangePanel(false) }}
                buttonName={'Fechar'}
                style={styleHistoryChangeButton}
            />
        )
    }

    async function deleteIdsSelecteds() {
        const parameters = {
            ids: selectsRecordsHistoryChange.join(",")
        };
        const response = await ExecuteAxios.api('delete', `/item-cost-month/by-ids-list/`, { params: parameters });
        if (response) {
            reloadHistoryChangePanel()
            ResetVariables.resetVariables(attributeList)
        }
        return response
    }

    return (
        <MiddlePanel isVisible={showHistoryChangePanel}>
            <LoadingIndicator loaded={recordsHistoryChange}>
                <Panel style={{
                    width: '780px',
                    height: '550px',
                    padding: '5px',
                    borderRadius: '10px',
                    backgroundColor: '#f5f5f5',
                    border: '1px solid #ccc',
                    boxShadow: '0px 0px 10px rgba(0, 0, 0, 30%)'
                }}>
                    <Panel titlePage={'Orçamento limite meses'}
                        style={panelListStyle}
                        canViewCRUD={true}
                        setUpdating={setUpdating}
                        putFunction={putProductOperation}
                        enableEdit={true}
                        canEdit={itemCostIdSelected && itemCostIdSelected.length == 1}
                        cancelFunction={cancelFunction}
                        canDelete={true}
                        enableDelete={selectsRecordsHistoryChange && selectsRecordsHistoryChange.length > 0}
                        deleteFunction={deleteIdsSelecteds}
                        recordsSelected={selectsRecordsHistoryChange}
                        resetVariables={() => { ResetVariables.resetVariables(attributeList) }}
                        inserting={false}
                        updating={updating}
                        componentRightButtons={closeButton()}
                        dataListedAttributes={recordsHistoryChangeDetail}
                        attributeList={attributeList}
                    >
                        {getPanelListOrDetail()}
                    </Panel>
                </Panel>
            </LoadingIndicator>
        </MiddlePanel >
    );
}

export default HistoryChangePanel;
